import { useTranslation } from 'react-i18next';
import { IllustrationPeopleCloud } from '@/common/components/Illustrations/IllustrationPeopleCloud';
import { IllustrationShield } from '@/common/components/Illustrations/IllustrationShield';
import { ModalLearning } from '@/common/components/ModalLearning/ModalLearning';
import { Translate } from '@/common/components/Translate/Translate';

export function ESInsuranceLearningCentre({
  onClose,
}: TESInsuranceLearningCentreProps) {
  const { t } = useTranslation();
  return (
    <ModalLearning.Root onClose={onClose} heightClass="h-[60rem]">
      <ModalLearning.Step
        title={t('dashboard.insurance_detail.learning_centre.es.step1.title')}
        description={
          <Translate i18nKey="dashboard.insurance_detail.learning_centre.es.step1.content" />
        }
        asset={<IllustrationShield />}
      />
      <ModalLearning.Step
        title={t('dashboard.insurance_detail.learning_centre.es.step2.title')}
        description={
          <Translate i18nKey="dashboard.insurance_detail.learning_centre.es.step2.content" />
        }
        asset={<IllustrationPeopleCloud />}
      />
    </ModalLearning.Root>
  );
}

export type TESInsuranceLearningCentreProps = {
  onClose: () => void;
};
